module.exports = __webpack_public_path__ + "images/providence_new_logo.png";


//////////////////
// WEBPACK FOOTER
// ./assets/providence_new_logo.png
// module id = 14
// module chunks = 0